import React, { useState, useEffect } from 'react';
import ReactTable from 'react-table';
import {Button,Card,Col,Row} from "reactstrap";
import FetchNotificationSubscriptionsTypesService from '../../../../../Service/DashboardServices/AmazonNotificationsServices/FetchNotificationSubscriptionsTypesService';
import DeleteNotificationSubscriptionService from '../../../../../Service/DashboardServices/AmazonNotificationsServices/DeleteNotificationSubscriptionService';
import CreateNotificationSubscriptionService from '../../../../../Service/DashboardServices/AmazonNotificationsServices/CreateNotificationSubscriptionService';
import CustomModal from '../../../../Components/Modals/CustomModal';

function NotificationsSubscriptionsTypes({ token, storeIntegerID,storeAccountID }) {
  const [selectedNotifications, setSelectedNotifications] = useState([]);
  const [notificationData, setNotificationData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [confirmationPopup, setConfirmationPopup] = useState(false);
  const [pendingAction, setPendingAction] = useState(null); // create // delete
  const [selectedNotification, setSelectedNotification] = useState(null);

  useEffect(() => {

      setIsLoading(true);
      console.log(storeIntegerID)
      console.log(storeAccountID)
      let data={integerID: storeIntegerID,
        sellerPartnerId:storeAccountID,
      }
  
      FetchNotificationSubscriptionsTypesService(token, data).then((res) => {
        if (res && res.notificationList) {
          setNotificationData(res.notificationList);
  
          const selected = res.notificationList
            .filter(item => item.isSubscribed)
            .map(item => item.id);
  
          setSelectedNotifications(selected);
        }
  
        setIsLoading(false);
      });
   
  }, [token, storeIntegerID,storeAccountID]);


  const handleCheckboxChange = (id) => {

    const checked = !selectedNotifications.includes(id);

    const notification = notificationData.find(item => item.id === id);

    setSelectedNotification(notification);
    setPendingAction(checked ? "create" : "delete");
    setConfirmationPopup(true);
};

const handleConfirmation = () => {

    if (!selectedNotification) return;

    if (pendingAction === "create") {

        CreateNotificationSubscriptionService(token, {
            integerID: storeIntegerID,
            sellerPartnerId: storeAccountID,
            notificationTypeId: selectedNotification.id
        }).then(res => {

            console.log(res);

            setSelectedNotifications(prev => [
                ...prev,
                selectedNotification.id
            ]);

            setConfirmationPopup(false);
        });

    } else {

        DeleteNotificationSubscriptionService(token, {
            integerID: storeIntegerID,
            sellerPartnerId: storeAccountID,
            notificationTypeId: selectedNotification.id
        }).then(res => {

            console.log(res);

            setSelectedNotifications(prev =>
                prev.filter(id => id !== selectedNotification.id)
            );

            setConfirmationPopup(false);
        });

    }
};

  const columns = [
    {
      Header: "Notification Types",
      accessor: "notification_type",
      style: { textAlign: "left" },
    },
    {
        Header: "Select",
        id: "checkbox",
        width: 100,
        Cell: ({ original }) => (
          <div className="d-flex justify-content-center w-100 pt-1">
            <input
                type="checkbox"
                checked={selectedNotifications.includes(original.id)}
                onChange={() => handleCheckboxChange(original.id)}
                style={{ cursor: "pointer" }}
            />
          </div>
        ),
      },
  ];

  return (
    <>
      <ReactTable
        data={notificationData}
        columns={columns}
        className="-fixed -highlight -striped"
        getTheadProps={() => {
          return {
            style: {
              overflowY: "hidden",
              background: "#B1FA63",
              color: "#243837",
            },
          };
        }}
        defaultPageSize={12}
        showPageSizeOptions={false}
        noDataText={isLoading ? "Loading..." : "No Data Found."}
      />
      <CustomModal
            isOpen={confirmationPopup}
            toggle={() => setConfirmationPopup(false)}
            size="md"
            className="curve-popup"
        >
            <Card className="curve-popup p-3">
                <Row>
                    <Col md={12}>

                    <h6>
                        <b>
                            {pendingAction === "create"
                            ? `Do you want to create Amazon subscription for "${selectedNotification && selectedNotification.notification_type}"?`
                            : `Do you want to delete Amazon subscription for "${selectedNotification && selectedNotification.notification_type}"?`}
                        </b>
                        </h6>

                        <div className="mb-2 d-flex justify-content-end mr-4 mt-4">

                            <Button
                                className="no-btn-background-color mr-2"
                                onClick={() => setConfirmationPopup(false)}
                            >
                                No
                            </Button>

                            <Button
                                className="btn-background-color"
                                onClick={handleConfirmation}
                            >
                                Yes
                            </Button>

                        </div>

                    </Col>
                </Row>
            </Card>
        </CustomModal>
    </>
    
  );
}

export default NotificationsSubscriptionsTypes;